import { render, staticRenderFns } from "./BatchViewItem.vue?vue&type=template&id=1abec5d6&scoped=true&"
import script from "./BatchViewItem.vue?vue&type=script&lang=js&"
export * from "./BatchViewItem.vue?vue&type=script&lang=js&"
import style0 from "./BatchViewItem.vue?vue&type=style&index=0&id=1abec5d6&scoped=true&lang=css&"
import style1 from "./BatchViewItem.vue?vue&type=style&index=1&id=1abec5d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1abec5d6",
  null
  
)

export default component.exports